import { memo } from 'react';
import { Box, Image } from '@betty/moonlight';
import BalanceCard from '../BalanceCard/BalanceCard';
import ScreenName from '../ScreenName/ScreenName';
import { Platform } from 'react-native';

function AccountShowCase() {
  return (
    <Box
      width="100%"
      height={{
        mobile: 'auto',
        tablet: 680,
        desktop: 680,
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Image
        name="account.AccountShowCase"
        borderRadius={{
          mobile: 'radius-0',
          tablet: 'radius-200',
          desktop: 'radius-200',
        }}
        alt="background-img"
        contentFit={Platform.select({
          ios: 'none',
          web: 'cover',
          android: 'cover',
        })}
        width="100%"
        height="100%"
        position="absolute"
      />
      <Box
        width={{
          mobile: '100%',
          tablet: '90%',
          desktop: '90%',
        }}
        padding="space-400"
        gap="space-400"
      >
        <ScreenName />
        <BalanceCard />
      </Box>
    </Box>
  );
}

export default memo(AccountShowCase);
